import apiClient from './api';
import { Custody, CreateCustodyDto, UpdateCustodyDto, SettleCustodyDto } from '../types/custodies.types';

export const custodiesService = {
  async getAll(status?: string, employeeId?: number, branchId?: number, fromDate?: string, toDate?: string): Promise<Custody[]> {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (employeeId) params.append('employeeId', employeeId.toString());
    if (branchId) params.append('branchId', branchId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    
    const response = await apiClient.get(`/Custodies?${params.toString()}`);
    return response.data;
  },

  async getLookup(): Promise<Custody[]> {
    const response = await apiClient.get('/Custodies/lookup');
    return response.data;
  },

  async getCentral(): Promise<Custody[]> {
    const response = await apiClient.get('/Custodies/central');
    return response.data;
  },

  async getById(id: number): Promise<Custody> {
    const response = await apiClient.get(`/Custodies/${id}`);
    return response.data;
  },

  async create(data: CreateCustodyDto): Promise<Custody> {
    const response = await apiClient.post('/Custodies', data);
    return response.data;
  },

  async update(id: number, data: UpdateCustodyDto): Promise<Custody> {
    const response = await apiClient.put(`/Custodies/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/Custodies/${id}`);
  },

  async settle(id: number, data: SettleCustodyDto): Promise<Custody> {
    const response = await apiClient.post(`/Custodies/${id}/settle`, data);
    return response.data;
  },

  async reopen(id: number): Promise<Custody> {
    const response = await apiClient.post(`/Custodies/${id}/reopen`);
    return response.data;
  },

  async getEmployeeDefaults(employeeId: number): Promise<{ branchId?: number; accountId?: number }> {
    const response = await apiClient.get(`/Custodies/employee/${employeeId}/defaults`);
    return response.data;
  },

  async generateCustodyNumber(): Promise<string> {
    const response = await apiClient.get('/Custodies/generate-code');
    return response.data;
  }
};